import { ref } from 'vue';
import callDevicesAPI from 'dashboard/api/callDevices';

// Module-scoped cache — fetched once per page load, shared across all callers.
const devices = ref([]);
let loaded = false;
let pending = null;

export async function loadCallDevices() {
  if (loaded) return;
  if (pending) {
    await pending;
    return;
  }

  pending = callDevicesAPI
    .inboxMap()
    .then(({ data }) => {
      devices.value = Array.isArray(data) ? data : (data.payload ?? []);
    })
    .catch(() => {
      // Fail silently — devices stays empty; button won't show.
    })
    .finally(() => {
      loaded = true;
      pending = null;
    });

  await pending;
}

export function useCallDevices() {
  // Trigger the fetch on first composable use (no-op on subsequent calls).
  loadCallDevices();

  const hasDeviceForInbox = inboxId =>
    devices.value.some(d => Number(d.inbox_id) === Number(inboxId));

  const deviceForInbox = inboxId =>
    devices.value.find(d => Number(d.inbox_id) === Number(inboxId));

  return {
    devices,
    loadCallDevices,
    hasDeviceForInbox,
    deviceForInbox,
  };
}
